module.exports = require('./helpers/bundle-url').getBundleURL('9U9Lq') + "arabesco.5a486fe3.png";